export const MACRO_KEY = {
  OTHER_MODULES_KEY: "other-modules",
  OVERVIEW_KEY: "overview",

  BUTTON: "button",
  COUNTDOWN: "countdown",
  ANNOUNCEMENTS: "announcements",
  CARDS: "cards",
  HTML: "html",
  TABS: "tabs",
  PANEL_SIMPLE: "panel-simple",
  IMAGE_SLIDER: "image-slider",
  TEXT_AND_TITLE: "text-and-title",
  SPACER_AND_DIVIDER: "spacer-and-divider",
  PANEL_ADVANCED: "panel-advanced",
  ADVANCED_TABS_GROUP: "advanced-tabs-group",
  ADVANCED_TABS_SINGLE: "advanced-tabs-single",
  TOOLTIPS_AND_FOOTNOTES: "tooltips-and-footnotes",
  BUTTON_INLINE: "button-inline",
  FOOTNOTE_DISPLAY: "footnote-display",

  NEWS: "news",
  PAGES: "pages",
  SPACES: "spaces",
  PEOPLE: "people",
  ORG_CHART: "org-chart",
  RECENTLY_ACTIVE: "recently-active",
  NEW_STARTERS: "new-starters",
  UPCOMING_BIRTHDAYS: "upcoming-birthdays",
  WORK_ANNIVERSARY: "work-anniversary",
};

export const WARNING_DIALOGUE = {
  EMPTY_LINK: [
    MACRO_KEY.BUTTON,
    MACRO_KEY.BUTTON_INLINE,
    MACRO_KEY.CARDS,
    MACRO_KEY.ANNOUNCEMENTS,
  ],
};
